// @flow
import { isRequired, isEmail } from '@clark-inc/clark-forms';

const HEADLINE = 'Tutor Sign in';

const FIELD_SETS = [
  {
    fieldSet: [
      {
        columns: { small: 1, large: 1 },
        fields: [
          {
            type: 'input',
            name: 'email',
            label: 'Email',
            placeholder: 'anthony@hiclark.com',
            validate: [isRequired, isEmail],
          },
        ],
      },
      {
        columns: { small: 1, large: 1 },
        fields: [
          {
            type: 'input',
            name: 'password',
            label: 'Password',
            placeholder: '************',
            inputType: 'password',
            hasShowHideButton: true,
            validate: [isRequired],
          },
        ],
      },
    ],
  },
];

export { HEADLINE, FIELD_SETS };



// WEBPACK FOOTER //
// ./src/constants/sign-in/index.js